import { configureStore } from "@reduxjs/toolkit"

import { authApi } from "./api/authAPI"
import { badgeApi } from "./api/badgeAPI"
import { coachApi } from "./api/coachAPI"
import { commsApi } from "./api/commsAPI"
import { companyApi } from "./api/companyAPI"
import { leaderboardApi } from "./api/leaderboardAPI"
import { messagingApi } from "./api/messagingAPI"
import { metricApi } from "./api/metricAPI"
import { newsfeedApi } from "./api/newsfeedAPI"
import { ovationApi } from "./api/ovationAPI"
import { productionApi } from "./api/productionAPI"
import { reactionApi } from "./api/reactionAPI"
import { summariesApi } from "./api/summariesAPI"
import { teamApi } from "./api/teamAPI"
import { userApi } from "./api/userAPI"
import rootReducer from "./rootReducer"

export const store: any = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({}).concat([
      authApi.middleware,
      badgeApi.middleware,
      userApi.middleware,
      commsApi.middleware,
      leaderboardApi.middleware,
      metricApi.middleware,
      coachApi.middleware,
      ovationApi.middleware,
      productionApi.middleware,
      messagingApi.middleware,
      summariesApi.middleware,
      teamApi.middleware,
      companyApi.middleware,
      reactionApi.middleware,
      newsfeedApi.middleware,
    ]),
  devTools: true,
})

export type RootState = ReturnType<typeof store.getState>
